export default function ({ route, redirect, req }) {
    const ua = process.server
        ? req.headers['user-agent']
        : navigator.userAgent;
    const isWeChat = ua.toLowerCase().match(/MicroMessenger/i) == "micromessenger";
    const inWx = route.name.startsWith('wx');

    if (!isWeChat && inWx) {
        redirect('/');
    }
    
    if (isWeChat && !inWx && route.query.from == 'wx') {
        redirect('/wx');
    }


}
